import {
  buildCanonicalUrl,
  buildHreflangLinks,
  localeFromPath,
  ogLocaleFor,
  resolveRobotsMeta,
  resolveSiteUrl,
} from '~/utils/seo'

/** Head document global : lang, canonical, hreflang, robots et métadonnées de partage liées à la page. */
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const route = useRoute()
  const { t }: { t: (key: string) => string } = useNuxtApp().$i18n
  const siteUrl: string = resolveSiteUrl(config.public.siteUrl)
  const langIndexable: boolean = config.public.langSeoIndexable

  const htmlLang = computed(() => localeFromPath(route.path))

  const headLinks = computed(() => [
    { rel: 'canonical', href: buildCanonicalUrl(siteUrl, route.path) },
    ...buildHreflangLinks(siteUrl, route.path, langIndexable),
  ])

  useHead({
    htmlAttrs: { lang: htmlLang },
    link: headLinks,
  })

  const robots = computed((): string | undefined => {
    const content: string | null = resolveRobotsMeta(
      config.public.seoIndexable,
      htmlLang.value,
      langIndexable,
    )
    return content ?? undefined
  })

  useSeoMeta({
    robots,
    ogUrl: (): string => buildCanonicalUrl(siteUrl, route.path),
    ogLocale: (): string => ogLocaleFor(htmlLang.value),
    ogImageAlt: (): string => t('seo.shareImageAlt'),
    twitterImageAlt: (): string => t('seo.shareImageAlt'),
  })
})
